import { PAGE_INITIAL, ORDER_INITIAL_HISTORICO } from '../../commons/constants';

export const initialState = {
  loading: false,
  publicacoes: [],
  error: false,
  page: {
    totalElements: 0,
    totalPages: 0,
    first: false,
    last: false,
    currentPage: PAGE_INITIAL,
    order: ORDER_INITIAL_HISTORICO,
  },
};

export default initialState;
